import { portalapi } from 'src/helpers/axios'
import { ErrorService } from "../helpers/errorplugin"
const $log = ErrorService
const state = { 
    status: {}, // { connected: boolean, session: {} }
    onnet: null
}; 
    
const getters = {
  isOnNet: state => state.onnet,
  isConnected: state => (state.status && state.status.connected),
  cpdSession: (state, getters) => getters.isConnected 
    ? state.status.session
    : null,
  status: state => state.status,
  isMacauth: (state,getters) => getters.isConnected ? (getters.cpdSession.authmode == 'm') : false,
  // connectedusername: state => (state.status && state.status.connected )
  //   ? state.status.session.username
  //   : null
}

const actions = {  
    checkOnnet: async ({ commit }) => {
      $log.onDebug("checking onnet status")
      try{
        await portalapi.get('/open/onnet').then((response) => {
          if (response.status === 200) {
            $log.onDebug(response.data)
            $log.onDebug("onnet = " + response.data)
            commit("setOnNet", response.data);
          }
        })
        .catch((error) => {      
          $log.onDebug('error fetching onnet' + error)
        })
  
      } catch (e) {      
        $log.onDebug(e);
      }
    },
    
};

const mutations = {
  setStatus(state, status) {
    $log.onDebug('status is now equal to ' + JSON.stringify(status))
    state.status = status
  },
  // convenience method, same as setStatus(null)
  setDisconnected(state) {
    state.status = {connected: false, status: null}
  },
  setOnNet: function(state, fact) {
    state.onnet = fact;
  },
};

export const captive = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};